import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Fill, ModalComponent, Trade } from 'common';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Chart, registerables } from 'chart.js';
import { Flow, SankeyController } from 'chartjs-chart-sankey';

@Component({
  selector: 'common-rebalancing-trade-fills-sankey-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, ModalComponent],
  templateUrl: './trade-fills-sankey-modal.component.html',
  styleUrls: ['./trade-fills-sankey-modal.component.scss'],
})
export class TradeFillsSankeyModalComponent implements OnChanges {
  @Input()
  public isOpen = false;

  @Output()
  public isOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public trade: Trade;

  @ViewChild('sankeyChart')
  private chartRef: ElementRef;

  public chart: Chart;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']?.currentValue) {
      setTimeout(() => {
        this.calculateSankeyChart();
      }, 1);
    }
  }

  private calculateSankeyChart(): void {
    if (this.trade.fill.subFills.length > 1) {
      const fills: Fill[] = [];
      const data: any[] = [];
      const colors: { [key: string]: string } = {};
      this.trade.fill.subFills.forEach(subFill => {
        fills.push(subFill);

        data.push({
          from: subFill.from.symbol,
          to: subFill.liquiditySource.readableName,
          flow: subFill.proportionInBps,
        });
        data.push({
          from: subFill.liquiditySource.readableName,
          to: subFill.to.symbol,
          flow: subFill.proportionInBps,
        });

        colors[subFill.liquiditySource.readableName] =
          '#' +
          (0x1000000 + Math.random() * 0xffffff).toString(16).substring(1, 7);
        colors[subFill.from.symbol] = subFill.from.sliderColor || 'red';
        colors[subFill.to.symbol] = subFill.to.sliderColor || 'green';
      });

      // @ts-ignore
      const getColor = (key: any) => colors[key];

      Chart.register(SankeyController, Flow, ...registerables);

      this.chart = new Chart(this.chartRef.nativeElement, {
        type: 'sankey',
        data: {
          datasets: [
            {
              label: 'Trade flow',
              data: data,

              colorFrom: c => getColor(c.dataset.data[c.dataIndex].from),
              colorTo: c => getColor(c.dataset.data[c.dataIndex].to),
              hoverColorFrom: c => getColor(c.dataset.data[c.dataIndex].from),
              hoverColorTo: c => getColor(c.dataset.data[c.dataIndex].to),
              colorMode: 'gradient', // or 'from' or 'to'

              size: 'max', // or 'min' if flow overlap is preferred
            },
          ],
        },
        options: {
          plugins: {
            tooltip: {
              callbacks: {
                label: context => {
                  const index = context.dataIndex / 2;
                  const percentage = fills[index].proportionInBps / 100;
                  const liqSourceName =
                    fills[index].liquiditySource.readableName;
                  const fromSymbol = fills[index].from.symbol;
                  const toSymbol = fills[index].to.symbol;
                  return `${percentage}% ${liqSourceName} (${fromSymbol}/${toSymbol})`;
                },
              },
            },
          },
        },
      });
    }
  }
}
